import { fontSizes } from "../sizes";

const chakraBaseStyle = {
  color: "emphasized",
  mb: "1.5",
  fontSize: "sm",
};

const baseStyle = {
  ...chakraBaseStyle,
  color: "black",
  fontSize: fontSizes.md,
};

const chakraSizes = {
  sm: {
    _peerPlaceholderShown: {
      fontSize: "sm",
      top: "1.5",
      left: "4",
    },
  },
  md: {
    _peerPlaceholderShown: {
      fontSize: "md",
      top: "2",
      left: "4",
    },
  },
  lg: {
    _peerPlaceholderShown: {
      fontSize: "lg",
      top: "2.5",
      left: "4",
    },
  },
};

const sizes = {
  ...chakraSizes,
  "2xl": { fontSize: fontSizes.x4l },
  xl: { fontSize: fontSizes.x2l },
  lg: { fontSize: fontSizes.x1l },
  md: { fontSize: fontSizes.md },
  sm: { fontSize: fontSizes.x1s },
  xs: { fontSize: fontSizes.x2s },
};

const chakraVariants = {
  inline: () => ({
    margin: 0,
    minW: "2xs",
  }),
  floating: () => ({
    position: "absolute",
    transition: "all 0.12s ease-in",
    pointerEvents: "none",
    top: "-27px",
    left: "0",
    _peerPlaceholderShown: {
      fontWeight: "normal",
      color: "subtle",
    },
    _peerFocus: {
      fontSize: "sm",
      fontWeight: "medium",
      top: "-27px",
      left: "0",
      color: "muted",
    },
  }),
};

const variants = {
  ...chakraVariants,
};

const chakraDefaultProps = {
  size: "md",
};

const defaultProps = {
  ...chakraDefaultProps,
};

export const FormLabel = {
  baseStyle,
  defaultProps,
  sizes,
  variants,
};
